export const isYoutubeUrl = (videoUrl?: string | null) =>
  /(?:youtube\.com|youtu\.be)/i.test(videoUrl || '');
